import styled from "@emotion/styled";

export const Container = styled.div`
  margin-top: 1.5625rem;
  @media (max-width: 767px) {
    overflow-x: scroll;
  }
`;

export const UpperContainer = styled.div``;

export const UpperTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
    button {
      width: 100%;
      margin-top: 20px;
    }
  }
`;

export const TextWrapper = styled.div``;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ContentWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 25px;
`;
